// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__bmlhC","row":"ProcedureTreatmentSummary_row__1dYRM"};